

export const GetPathBeforeClientCode=(url:string)=>{
    
    
let splittedUrl= url.split("/")

let finalUrl=""
for(let i=1;i<splittedUrl.length-1;i++){
    finalUrl+="/"+splittedUrl[i]
}

return finalUrl
}